'use strict';

angular.module('user')
    .controller('ApiAuthLoginController', ['AccountManager', 'ShareCrfApiErrorCodes', function(AccountManager, ShareCrfApiErrorCodes) {
        var vm = this;

        vm.$onInit = function() {
            vm.data = {};

            vm.running = false;
            vm.submit = function() {
                if (!vm.running) {
                    vm.running = true;

                    return AccountManager.login(vm.data.email, vm.data.password)
                        .then(function() {
                            vm.message = null;
                            vm.warn = null;
                            vm.error = null;

                            vm.onLogin()
                                .then(function() {
                                    vm.running = false;
                                })
                                .catch(function() {
                                    vm.running = false;
                                });
                        })
                        .catch(function(error) {
                            vm.running = false;

                            vm.message = null;
                            vm.warn = null;
                            vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                        });
                }
            };
        };
    }]);
